/** DataBest — KPI card. Icon + big value + label. */
import React from "react";

const KpiCard = ({ icon: Icon, label, value, hint, tone = "blue", testId, loading = false }) => {
    const TONES = {
        blue: {
            border: "border-brand-blue-100",
            bg: "bg-brand-blue-50",
            iconBg: "bg-brand-blue-100 text-brand-blue-700",
            value: "text-brand-blue-950",
        },
        green: {
            border: "border-brand-green-100",
            bg: "bg-brand-green-50",
            iconBg: "bg-brand-green-100 text-brand-green-700",
            value: "text-brand-green-900",
        },
        violet: {
            border: "border-violet-100",
            bg: "bg-violet-50",
            iconBg: "bg-violet-100 text-violet-700",
            value: "text-violet-900",
        },
        amber: {
            border: "border-amber-100",
            bg: "bg-amber-50",
            iconBg: "bg-amber-100 text-amber-700",
            value: "text-amber-900",
        },
    };
    const t = TONES[tone] || TONES.blue;
    const hasData = value !== undefined && value !== null && value !== "—";
    return (
        <div
            data-testid={testId}
            aria-busy={loading || undefined}
            className={`relative rounded-2xl border ${t.border} ${t.bg} p-4 sm:p-5 transition-opacity ${
                loading && hasData ? "opacity-70" : ""
            }`}
        >
            <div className="flex items-center gap-3">
                <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${t.iconBg}`}>
                    <Icon className="h-4 w-4" />
                </div>
                <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
                    {label}
                </p>
            </div>
            {loading && !hasData ? (
                <>
                    <div className="mt-3 h-8 w-24 animate-pulse rounded-md bg-slate-200/80" />
                    <div className="mt-2 h-3 w-32 animate-pulse rounded-md bg-slate-200/60" />
                </>
            ) : (
                <>
                    <p className={`mt-3 text-3xl font-black tabular-nums ${t.value}`}>
                        {value ?? "—"}
                    </p>
                    {hint && (
                        <p className="mt-1 text-[11px] text-slate-500">{hint}</p>
                    )}
                </>
            )}
        </div>
    );
};

export default KpiCard;
